import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { Box } from '@dealstack/frontend/shared/components/Box/Box';
import { Expandable } from '@dealstack/frontend/shared/components/Expandable/Expandable';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import {
	TransMipCreate,
	useTranslationMipCreate,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const ContractsExpandable = ({ className }: Props) => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<Expandable title={tMipCreate('contracts.expandable.title')}>
			<div className={className}>
				<Text variant="p-md">
					<TransMipCreate i18nKey="contracts.expandable.text_1" />
				</Text>
				<Text variant="p-md" bold>
					<TransMipCreate i18nKey="contracts.expandable.list_item_1" />
				</Text>

				<Text variant="p-md" bold>
					<TransMipCreate i18nKey="contracts.expandable.list_item_2" />
				</Text>

				<Text variant="p-md">
					<TransMipCreate i18nKey="contracts.expandable.text_2" />
				</Text>

				<ExamplesWrapper>
					<PaymentInstructionsSection>
						<ColumnWrapper gridAreaName="parties">
							<Text variant="p-lg" bold>
								{tMipCreate('contracts.expandable.parties')}
							</Text>
							<AssetWrapper>
								<AssetsLoader src="/context/admin/new-deal-contracts/parties.png" />
							</AssetWrapper>
						</ColumnWrapper>

						<ColumnWrapper gridAreaName="securities">
							<Text variant="p-lg" bold>
								{tMipCreate('contracts.expandable.securities')}
							</Text>

							<AssetWrapper>
								<AssetsLoader src="/context/admin/new-deal-contracts/securities.png" />
							</AssetWrapper>
						</ColumnWrapper>
					</PaymentInstructionsSection>
				</ExamplesWrapper>
			</div>
		</Expandable>
	);
};

const ExamplesWrapper = styled(Box)``;

const PaymentInstructionsSection = styled.div`
	display: grid;
	grid-template-areas: 'parties securities';
	grid-column-gap: 1.5rem;
`;
const AssetWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[200]};
	border-radius: 6px;
	padding: 1.375em;
	flex: 1;
`;
const ColumnWrapper = styled.div<{ gridAreaName: string }>`
	max-width: 40rem;
	max-height: 13rem;

	.img {
		max-width: 100%;
		max-height: 100%;
	}

	display: flex;
	flex-direction: column;
	grid-area: ${(props) => props.gridAreaName};
`;

const Memoized = memo(ContractsExpandable);
const Styled = styled(Memoized)`
	display: flex;
	flex-direction: column;
	gap: 1em;

	white-space: pre-line;

	${ExamplesWrapper} {
		margin-top: 0.5em;
		padding: 0.5em;
	}

	${AssetWrapper} {
		margin-top: 0.5em;
	}

	ul {
		list-style: decimal;
		margin-left: 2em;
	}

	strong {
		font-weight: bold;
	}
`;

export { Styled as ContractsExpandable };
